import { render } from "./AllTables.vue?vue&type=template&id=38aa74c0"
import script from "./AllTables.vue?vue&type=script&lang=js"
export * from "./AllTables.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__